export default __webpack_public_path__ + "2eccd0bafcb88c8c2f68a0ab5de542ca.svg";